var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menus-wrap",staticStyle:{"border":"1px solid #eee"}},[(_vm.id)?[_c('success-view')]:[_c('promise-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.active === 1),expression:"active === 1"}],on:{"update:active":function (val) {
					_vm.active = val;
				}}}),_c('form-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.active === 2),expression:"active === 2"}],on:{"update:active":function (val) {
					_vm.active = val;
				}}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }